module.exports = __webpack_public_path__ + "static/media/react.b832d193.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/react.svg
// module id = 36
// module chunks = 0